
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminSettings from '@/pages/AdminSettings';
import AdminProfile from '@/pages/AdminProfile';
import AdminReferralUsers from '@/pages/AdminReferralUsers';
import AdminSignupForm from '@/pages/AdminSignupForm';
import AdminBusinessSetup from '@/pages/AdminBusinessSetup';
import AdminReports from '@/pages/AdminReports';
import AdminPlans from '@/pages/AdminPlans';
import AdminSupportManagement from '@/pages/AdminSupportManagement';
import AdminKnowledgeBase from '@/pages/AdminKnowledgeBase';
import AdminAutoUsers from '@/pages/AdminAutoUsers';
import AdminCampaigns from '@/pages/AdminCampaigns';
import AdminEcommerceCampaigns from '@/pages/AdminEcommerceCampaigns';
import AdminPayments from '@/pages/AdminPayments';
import UserManagementPage from '@/pages/admin/UserManagementPage';
import CRMPage from '@/pages/admin/CRMPage';
import NotFound from '@/pages/NotFound';
import AdminRewardPurchasePage from "@/pages/admin/AdminRewardPurchasePage";
import MarketingDashboardPage from '@/pages/admin/MarketingDashboardPage';
import CreateBannerPage from '@/pages/admin/CreateBannerPage';
import ManageBannersPage from '@/pages/admin/ManageBannersPage';
import AIBannerPage from '@/pages/admin/AIBannerPage';

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<AdminDashboard />} />
      <Route path="/settings" element={<AdminSettings />} />
      <Route path="/profile" element={<AdminProfile />} />
      <Route path="/user-management" element={<UserManagementPage />} />
      <Route path="/crm/*" element={<CRMPage />} />
      <Route path="/referral-users" element={<AdminReferralUsers />} />
      <Route path="/signup-form" element={<AdminSignupForm />} />
      <Route path="/business-setup" element={<AdminBusinessSetup />} />
      <Route path="/reports" element={<AdminReports />} />
      <Route path="/campaigns" element={<AdminCampaigns />} />
      <Route path="/ecommerce-campaigns" element={<AdminEcommerceCampaigns />} />
      <Route path="/plans" element={<AdminPlans />} />
      <Route path="/payments" element={<AdminPayments />} />
      <Route path="/support" element={<AdminSupportManagement />} />
      <Route path="/knowledge-base" element={<AdminKnowledgeBase />} />
      <Route path="/auto-users" element={<AdminAutoUsers />} />
      <Route path="/reward-purchase" element={<AdminRewardPurchasePage />} />
      
      {/* Marketing Routes */}
      <Route path="/marketing" element={<MarketingDashboardPage />} />
      <Route path="/marketing/create" element={<CreateBannerPage />} />
      <Route path="/marketing/manage" element={<ManageBannersPage />} />
      <Route path="/marketing/ai-banner" element={<AIBannerPage />} />
      
      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  );
};

export default AdminRoutes;
